const path = '/img/activity/lvs';

export const HEADER_MENUS = ['活动介绍', '议程内容', '精彩瞬间'];

export const BANNER_DATA = {
  prefix: '2022北京站',
  title: 'LiveVideoStackCon',
  backgroundImage: `${path}/banner.webp`,
  backgroundImageMobile: `${path}/banner-mobile.webp`,
  subTitle: 'StreamLake音视频技术创新与应用',
  info: '2023/03/31 - 2023/04/01 中国·北京',
  partners: [
    `${path}/lvsc.webp`,
    `${path}/lvs.webp`,
    `${path}/streamlake.webp`,
    `${path}/nvidia.webp`,
  ],
};

export const DESCRIPTION = {
  title: {
    main: '活动介绍',
    vice: 'ACTIVITY DESCRIPTION',
  },
  content:
    '视频化已是各行业大势所趋，激发出多元化需求。面临机遇与挑战，快手StreamLake专注于成为视频化升级助推器，推出视频化升级全链路解决方案。\r\n3月31日- 4月1日，快手StreamLake亮相LiveVideoStack音视频北京站，展示了一站式音视频+AI解决方案。',
};

export const AGENDA_CONTENT = {
  title: {
    main: '议程内容',
    vice: 'AGENDA CONTENT',
  },
  speech: {
    title: '主题演讲',
    content: [
      {
        title: '汇聚音视频新能量，探索行业新蓝海',
        interval: '10:45-11:30',
        speaker: '于冰',
        identity: '快手高级副总裁、研发线负责人',
        portrait: '',
        link: '',
        contentId: '',
      },
    ],
  },
  agenda: {
    title: '专场议程',
    content: [
      {
        title: '快手智能处理与编码算法产品化之路',
        interval: '09:30-10:25',
        speaker: '陈宇聪',
        identity: '快手视频图像算法引擎负责人',
        portrait: '',
        link: '',
        contentId: '',
      },
      {
        title: '媒体传输协议的演进与未来',
        interval: '10:30-11:25',
        speaker: '周超',
        identity: '快手传输算法负责人',
        portrait: '',
        link: '',
        contentId: '',
      },
      {
        title: '打造音视频极致消费体验',
        interval: '11:30-12:25',
        speaker: '苍鹏',
        identity: '快手播放技术中心负责人',
        portrait: '',
        link: '',
        contentId: '',
      },
    ],
  },
};

export const MOMENT = {
  title: {
    main: '精彩瞬间',
    vice: 'WONDERFUL MOMENT',
  },
  image: `${path}/moment.webp`,
};
